module.exports = __webpack_public_path__ + "media/images/badges/akt/AKT_BadassLoyaltyProgram_Badges_116x116_7-5bb929a2bcb2ee433e5a0b3338c587e1.png";